// @ts-ignore - colord has module resolution issues in strict mode
import { colord } from "colord";
import type { HTMLProps } from "react";
import styled from "styled-components";

interface Props extends HTMLProps<HTMLTextAreaElement> {
	onChangeText?: (str: string) => any;
	onDark?: boolean;
	label?: string;
}

export const TextArea: React.FC<Props> = ({ onChange, onChangeText, onDark, className, label, ...props }) => {
	return (
		<Styles className={`${className ?? ""} ${onDark && "on-dark"}`}>
			{label && <label>{label}</label>}
			<textarea {...props} onChange={(e) => (onChangeText ? onChangeText(e.target.value) : onChange && onChange(e))} />
		</Styles>
	);
};

const Styles = styled.div`
	label {
		display: block;
		font-size: 0.75rem;
		font-weight: 600;
		margin: 0 0 5px 0;
	}

	textarea {
		border-style: none;
		display: block;
		width: 100%;
		font-size: 1rem;
		font-family: ${(props) => props.theme.font.family};
		padding: 0;
		background-color: transparent;
		/* margin-bottom: 0.3rem; */
		min-height: 150px;

		&:focus {
			outline: none;
		}
	}

	&.on-dark {
		border-color: ${(props) => colord(props.theme.colors.divider).darken(0.3).toHex()};
	}

	padding: 5px 6px 3px 8px;
	background: white;
	border: 1px solid ${(props) => props.theme.colors.divider};
	border-radius: 3px;
`;
